import React, { useEffect, useState } from "react";
import { GraduationCap } from "lucide-react";
import api from "../lib/api";
import { avatarColorsFromName } from "./UserAvatar";

const cache = new Map(); // courseId -> Promise<objectURL|null>

const fetchCover = (courseId, version) => {
  const key = `${courseId}@${version || ""}`;
  if (!cache.has(key)) {
    cache.set(
      key,
      api.get(`/formazione/courses/${courseId}/cover`, { responseType: "blob" })
        .then(({ data }) => URL.createObjectURL(data))
        .catch(() => null)
    );
  }
  return cache.get(key);
};

export const invalidateCover = (courseId) => {
  for (const key of [...cache.keys()]) {
    if (key.startsWith(`${courseId}@`)) cache.delete(key);
  }
};

export const CourseCover = ({ courseId, hasCover, title, version, className = "", testId }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!courseId || !hasCover) { setSrc(null); return undefined; }
    let alive = true;
    fetchCover(courseId, version).then((url) => { if (alive) setSrc(url); });
    return () => { alive = false; };
  }, [courseId, hasCover, version]);

  if (src) {
    return (
      <img
        src={src}
        alt={title || "copertina corso"}
        data-testid={testId}
        className={`object-cover w-full h-full ${className}`}
      />
    );
  }
  const colors = avatarColorsFromName(title);
  return (
    <div
      data-testid={testId}
      aria-hidden="true"
      className={`w-full h-full flex items-center justify-center ${className}`}
      style={{ background: colors.bg, color: colors.fg }}
    >
      <GraduationCap size={36} strokeWidth={1.5} />
    </div>
  );
};
